import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Reassign Candidate|Cert Requirements|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPToolsReassignCandidateCreqs';
export type SPToolsReassignCandidateCreqsLocNames =
	| `${LocNameStart}LabelCReqName`
	| `${LocNameStart}LabelCReqType`
	| `${LocNameStart}LabelCReqActiveDate`
	| `${LocNameStart}LabelCReqExpireDate`;

export const spToolsReassignCandidateCreqsLocs: LocDefs<SPToolsReassignCandidateCreqsLocNames> = {
	SPToolsReassignCandidateCreqsLabelCReqName: {
		defaultValue: 'Name',
		description: 'Label for CReq Name',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.CReqName',
		...sharedProperties,
	},
	SPToolsReassignCandidateCreqsLabelCReqType: {
		defaultValue: 'Type',
		description: 'Label for CReq Type',
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.CReqType',
		...sharedProperties,
	},
	SPToolsReassignCandidateCreqsLabelCReqActiveDate: {
		defaultValue: 'Active Date',
		description: 'Label for CReq Active Date',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.CReqActiveDate',
		...sharedProperties,
	},
	SPToolsReassignCandidateCreqsLabelCReqExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Label for CReq Expire Date',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.CReqExpireDate',
		...sharedProperties,
	},
};

export type SPToolsReassignCandidateCreqsLocType = LocMap<SPToolsReassignCandidateCreqsLocNames>;
